/**
 * @desc Yung-分页获取字典列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.BaseDictionaryResponseDto>
>;
export function request(
  body: defs.basics.BaseDictionaryQueryDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/dataDictionary/findList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
